import React, { useContext, useEffect, useState } from 'react';

import moment from 'moment';

import { GlobalContext } from '../../../store';
import { IEventItem } from '../../../store/player/events/store';

import HandicapIndex from '../../../components/HandicapIndex';
import NextEvent from '../../../components/NextEvent/NextEvent';
import { ClubEventToday } from '../Home/ClubEventToday/ClubEventToday';
import EventToday from './EventToday/EventToday';
import { today } from '../../../Utils/today';
import UpcomingEvents from '../Home/Components/UpcomingEvents/UpcomingEvents';

interface IProps {
  clubId: string;
}

export const ClubHome = (props: IProps) => {
  const { clubId } = props;

  const {
    actions: {
      clubs: { all: getAllClubs },
      games: { getAllFutureClubGames },
      events: { getAllFutureClubEvents }
    },
    events
  } = useContext(GlobalContext);

  const [gamesHasBeenRetrieved, setGamesHasBeenRetrieved] = useState(false);

  useEffect(() => {
    if (!gamesHasBeenRetrieved) {
      setGamesHasBeenRetrieved(true);

      getAllClubs();
      getAllFutureClubGames(clubId, true).catch();
      getAllFutureClubEvents(clubId, true).catch();
    }
  }, [gamesHasBeenRetrieved]);

  const allEvents: IEventItem[] = Object.values(events.all)
    .filter(event => event.club.id === Number(clubId))
    .sort((a, b) => (a.start > b.start ? 1 : -1));

  const nextEvent = allEvents.find(
    ({ start, enrollment: { status } }) => moment(start).isAfter(today) && status === 'active'
  );

  return (
    <div className="home club-home">
      <EventToday clubId={Number(clubId)} />

      <ClubEventToday clubId={Number(clubId)} />

      <HandicapIndex clubId={clubId} />

      <UpcomingEvents />

      <NextEvent item={nextEvent} />
    </div>
  );
};
